import { render, staticRenderFns } from "./claim-log-view.vue?vue&type=template&id=3040d554&"
import script from "./claim-log-view.vue?vue&type=script&lang=ts&"
export * from "./claim-log-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports